// import pic1 from "./img/proj1.png";
import pic3 from "./img/proj3.png";
// import pic4 from "./img/proj4.png";
// import pic5 from "./img/proj5.png";

export const projects = [
  {
    title: "Daily Expense Tracker App",
    image: pic3,
    description:
      "Daily Expense Tracker app involves two main modules: Transaction and Categories, each managed by its respective controller. The Transaction controller handles CRUD operations for tracking daily expenses, allowing users to input, view, modify, and delete expense records. The Categories controller manages the different categories of expenses, such as groceries, utilities, and entertainment, enabling better organization and classification of transactions and additionally Dashboard shows the data in chart. Entity Framework is used for data access, simplifying the interaction with the SQL Server database.",
    tools: ["ASP.NET MVC", "SQL Server", "Entity Framework"],
    github: "https://github.com/Deepangshi/Daily-Expenses-App.git",
    link: "https://github.com/Deepangshi/Daily-Expenses-App.git",
  },
];
